import { httpsCallable } from "firebase/functions";
import { Timestamp } from "firebase/firestore";
import { functions } from "./firebase";
const eventName = "staff-data-changed";
export const staffDataChanged = () => window.dispatchEvent(new Event(eventName));
export function encodeStaffData(value) {
  if (value?._methodName === "serverTimestamp") return { __staffType: "serverTimestamp" };
  if (value && typeof value.toMillis === "function") return Number.isInteger(value.seconds) ? { __staffType: "timestamp", seconds: value.seconds, nanoseconds: value.nanoseconds } : { __staffType: "timestamp", millis: value.toMillis() };
  if (value && typeof value === "object" && Number.isInteger(value.seconds) && Object.keys(value).every(key=>["seconds","nanoseconds"].includes(key))) return { __staffType: "timestamp", seconds: value.seconds, nanoseconds: value.nanoseconds||0 };
  if (value instanceof Date) return { __staffType: "timestamp", millis: value.getTime() };
  if (Array.isArray(value)) return value.map(encodeStaffData);
  if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).filter(([,v]) => v !== undefined).map(([k,v])=>[k,encodeStaffData(v)]));
  return value;
}
const decode = value => value && typeof value === "object" && Object.keys(value).every(k => ["seconds", "nanoseconds"].includes(k)) && Number.isFinite(value.seconds)
  ? new Timestamp(value.seconds,value.nanoseconds||0) : Array.isArray(value) ? value.map(decode) : value && typeof value === "object" ? Object.fromEntries(Object.entries(value).map(([k,v])=>[k,decode(v)])) : value;
export async function mutateStaff(operations) {
  await httpsCallable(functions,"staffMutate",{timeout:120000})({operations:encodeStaffData(operations)});
  staffDataChanged();
}
export function subscribeStaffDirectory(next, error) {
  let active=true,loading=false,again=false;
  const refresh=async()=>{
    if(!active)return;
    if(loading){again=true;return;}
    loading=true;
    try{const response=await httpsCallable(functions,"staffDirectory",{timeout:60000})({});if(active)next(decode(response.data));}
    catch(failure){if(active)error(failure);}
    finally{loading=false;if(again){again=false;void refresh();}}
  };
  const focus=()=>{if(document.visibilityState!=="hidden")void refresh();};
  void refresh();const timer=setInterval(focus,30000);
  window.addEventListener(eventName,refresh);window.addEventListener("focus",focus);document.addEventListener("visibilitychange",focus);
  return()=>{active=false;clearInterval(timer);window.removeEventListener(eventName,refresh);window.removeEventListener("focus",focus);document.removeEventListener("visibilitychange",focus);};
}
